// extracted by mini-css-extract-plugin
var _1 = "AqCephsPYl";
var _2 = "NaFUQS47tT";
var _3 = "bNnVtJPe3t";
var _4 = "E5Ag7OISL2";
var _5 = "LCZgvZUVz9";
var _6 = "NcZjZDmSC1";
var _7 = "O3MNUaUbuD";
var _8 = "NyXJQWtN_h";
export { _1 as "body", _2 as "bodyAlt", _3 as "main", _4 as "mainAlt", _5 as "nav", _6 as "navAlt", _7 as "sidebar", _8 as "topbar" }
